// src/components/GlitchText.tsx
"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect } from "react";

// Premium Brutalist / Cyberpunk Palette (high-contrast on both white and black backgrounds)
const COLORS = ["#FF4F00",
// Fiery Orange (Matches Ember Theme)
"#00B0FF",
// Vivid Electric Blue
"#00E676",
// Toxic/Neon Green
"#BD00FF",
// Synthwave Purple
"#FF2A85" // Neon Rose/Pink
];
let colorIndex = 0;
export default function GlitchText(t0) {
  const $ = _c(8);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /[\u0600-\u06FF]/;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = t1.test(text);
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isArabic = t2;
  let t3;
  if ($[3] !== isArabic || $[4] !== text) {
    const parts = isArabic ? text.split(/(\s+)/) : text.split("");
    t3 = parts.map(_temp);
    $[3] = isArabic;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <>{t3}</>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(char, index) {
  return <HoverChar key={index} char={char} />;
}
function HoverChar(t0) {
  const $ = _c(10);
  const {
    char
  } = t0;
  const [color, setColor] = useState(undefined);
  const timeoutRef = useRef(null);
  const lastHoverRef = useRef(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      const now = Date.now();
      if (now - lastHoverRef.current < 150) {
        return;
      }
      lastHoverRef.current = now;
      const nextColor = COLORS[colorIndex];
      colorIndex = (colorIndex + 1) % COLORS.length;
      setColor(nextColor);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMouseEnter = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setColor(undefined);
      }, 2000);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleMouseLeave = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  const t5 = color || "inherit";
  const t6 = color ? "none" : "color 0.1s ease";
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = {
      color: t5,
      transition: t6
    };
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = char === " " ? "\xA0" : char;
  let t9;
  if ($[7] !== t7 || $[8] !== t8) {
    t9 = <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={t7} className="relative z-10">{t8}</span>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}